<template>
  <div class="ma-4">
    <booking-overview-tabs />
  </div>
</template>

<script>
import BookingOverviewTabs from '../../booking/BookingOverviewTabs'
export default {
  name: 'BookingOverview',
  components: { BookingOverviewTabs },
}
</script>
